import React from 'react';
import { useTranslation } from 'react-i18next';
import './_styles_/AmqpVhostsTable.css';
import { vhostsType } from '../../types';
import AmqpVhostsTableRow from './AmqpVhostsTableRow';

AmqpVhostsTable.propTypes = {
    vhosts: vhostsType.isRequired,
};

function AmqpVhostsTable(props) {
    const {
        vhosts,
    } = props;
    const { t } = useTranslation();
    return (
        <div className="settings-detail-tab--amqp-vhosts">
            <div className="field">
                <span className="field--key">{t('settings.amqp.vhosts.title')}</span>
                <div className="detail-list">
                    <div className="detail-list-row detail-list-header">
                        <div className="amqp-vhost-cell amqp-vhosts-table-row--header--virtual-host">{t('settings.amqp.vhosts.virtual-host')}</div>
                        <div className="amqp-vhost-cell amqp-vhosts-table-row--header--connection-status">{t('settings.amqp.vhosts.connection-status')}</div>
                        <div className="amqp-vhost-cell amqp-vhosts-table-row--header--node">{t('settings.amqp.vhosts.node')}</div>
                    </div>
                    {vhosts.map((vhost) => (
                        <AmqpVhostsTableRow
                            key={vhost.virtualHost}
                            vhost={vhost}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}

export default AmqpVhostsTable;
